import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UIState } from '@shared/directives/ui-state/ui-state.directive';
import { HubMode, Learnspace } from '@shared/models';

export interface ProgramListItemActionButtonConfiguration {
  label: string;
  action: () => void;
}

@Component({
  selector: 'program-list-item',
  templateUrl: './program-list-item.component.html',
  styleUrls: ['./program-list-item.component.scss']
})
export class ProgramListItemComponent {
  @Input() learnspace?: Learnspace;
  @Input() title: string;
  @Input() description: string;
  @Input() tags?: string[];
  @Input() poster: string;
  @Input() showCollaborators = false;
  @Input() participantCount?: number;
  @Input() experienceCount?: number;
  @Input() showExperienceCount = true;
  @Input() clickDeactived = false;
  @Input() canDelete = false;
  @Input() accessProtected = false;
  @Input() canNotEnter = false;
  @Input() isArchived = false;
  @Input() showMenu = false;
  @Input() actionButtons?: ProgramListItemActionButtonConfiguration[];
  @Input() canCreateSpace?: boolean;
  @Input() hasRoleToCreateSpace?: boolean;
  @Input() canEdit = true;
  
  @Output() enter = new EventEmitter<void>();
  @Output() showParticipants = new EventEmitter<void>();
  @Output() update = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() unsubscribe = new EventEmitter<void>();
  @Output() contactSales = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();

  mode = HubMode.program;

  private states: Record<number, UIState | undefined> = {}

  getStateFor(i: number): UIState {
    return this.states[i] || UIState.default;
  }

  async handleClick(i: number) {
    try {
      this.states[i] = UIState.inprogress;
      await this.actionButtons[i].action();
      this.states[i] = UIState.default;
    } catch {
      this.states[i] = UIState.error;
    }
  }
}
